import * as React from 'react';
import {IMenuComponentProps} from "./IMenuComponentProps";
import {IMenuComponentState} from "./IMenuComponentState";
import 'src/assets/css/main.css';
import 'src/assets/css/reset.css';
import 'src/assets/css/fonts.css';
import logo from 'src/assets/images/logo.png'
import points from 'src/assets/images/points.png'
import {connect} from 'react-redux'
import * as action from 'src/actions/categoryAction'
import * as gifActions from 'src/actions/gifAction'
import {Placeholder} from 'semantic-ui-react'
import Popup from 'reactjs-popup'
import {withRouter} from "react-router-dom";

class MenuComponent extends React.Component<IMenuComponentProps, IMenuComponentState> {

    constructor(props: IMenuComponentProps) {
        super(props)

        // Default state
        this.state = {
            categories: [],
            loading: true
        }
    }

    componentDidMount() {
        let categorie = []
        this.props.fetchCategories(() => {

            if (this.props.categories && this.props.categories.length > 0) {
                this.props.categories.map((item, index) => {
                    if (index !== 0)
                        categorie.push(item)
                })
                this.setState({
                    categories: categorie.sort((a, b) => {
                        return parseInt(a.priority) - parseInt(b.priority)
                    }),
                    loading: false

                }, () => {
                    console.log(this.state.categories)
                })
            }
        })
    }

    fetchCategory = (cat, name) => {

        this.props.fetchTagsByCategory(cat)
            .then((tags) => {
                this.props.handleSearch(tags, () => {
                    this.props.history.push({
                        pathname: '/search',
                        state: name
                    })
                })
            })
    }

    public render() {

        const Menu = () => (
            <div className="menu-man">
                {
                    this.state.categories.slice(4, this.state.categories.length).length === 0 ?
                        <div><a>pas plus de catégories</a></div> :
                        this.state.categories.slice(6, this.state.categories.length)
                            .map((cat, index) => (
                                <div
                                    key={index}
                                    style={{
                                        textAlign: 'center',
                                        margin: '5px',
                                        justifyContent: 'space-between'
                                    }}
                                    onClick={() => this.fetchCategory(cat.id, cat.name)}
                                >
                                    <a
                                        style={{
                                            color: '#434344',
                                            textAlign: 'center',
                                            fontSize: '13px',
                                            fontFamily: 'Gotham_Bold',
                                            textTransform: 'uppercase',
                                            margin: '5px',
                                            cursor: 'pointer'
                                        }}>
                                        {cat.name}
                                    </a>
                                    {
                                        index !== (this.state.categories.length - 5) ?
                                            <hr style={{marginTop: '5px'}}/> :
                                            null
                                    }
                                </div>

                            ))}
            </div>
        );
        const {categories} = this.state
        return (

            <div className="_topMenu">

                <nav className="container">
                    <div onClick={() => {
                        this.props.history.push('/')
                    }} className="logo _ctn" style={{marginRight: '70px'}}>
                        <img src={logo} style={{cursor: 'pointer'}} alt="" id='logogif'/>
                    </div>

                    <div className="menu _ctn" style={{marginRight: '160px'}}>
                        {this.state.loading
                            ?
                            <Placeholder
                                style={{
                                    width: '150px',
                                    height: '15px'
                                }}>
                            </Placeholder>
                            :
                            (<ul>
                                {
                                    this.state.categories.slice(0, 6).map((cat, index) => (
                                        <li key={index} onClick={() => this.fetchCategory(cat.id, cat.name)}>
                                            <a>{cat.name}</a></li>
                                    ))
                                }
                            </ul>)}

                    </div>
                    <div className="categories _ctn">
                        <div className="points _insideCtn" style={{marginRight: '5px'}}>
                            <img src={points} alt=""/>
                        </div>


                        <Popup
                            trigger={<a className="text _insideCtn">plus des categories</a>}
                            position="bottom center" on="hover">
                            <Menu/>
                        </Popup>

                    </div>
                </nav>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {categories: state.categories.categories};
}

const mapDispatchToProps = (dispatch: any, ownProps: IMenuComponentProps) => {
    return {
        fetchCategories: (cb) => dispatch(action.fetchCategories(cb)),
        fetchTagsByCategory: (cat) => dispatch(action.fetchTagsByCategory(cat)),
        handleSearch: (text, cb) => dispatch(gifActions.search(text, cb))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MenuComponent))



// WEBPACK FOOTER //
// ./src/components/menuComponent/MenuComponent.tsx